import { render, staticRenderFns } from "./DiagramsToCompareBox.vue?vue&type=template&id=72ad6da4&scoped=true&"
import script from "./DiagramsToCompareBox.vue?vue&type=script&lang=ts&"
export * from "./DiagramsToCompareBox.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramsToCompareBox.vue?vue&type=style&index=0&id=72ad6da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad6da4",
  null
  
)

export default component.exports